import { useTranslate } from '@ur-solutions/react-hooks'
import { ExportSection } from '../components/ExportsSettings/components'
import { ExportSalaryCorrectionsCard } from '../components/ExportsSettings/export-salary-corrections-card'

export function ExportSalary() {
  const translations = useTranslate({
    salary: 'common.salary',
  })

  return (
    <ExportSection header={translations.salary}>
      <ExportSalaryCorrectionsCard />
    </ExportSection>
  )
}
